export const joinReducer = (state, {type, payload}) => {
    switch (type) {
        case "join":
            return {
                isJoin:true,
                memberCount: state.memberCount + 1
            };
        case "leave":
            return {
                isJoin:false,
                memberCount: state.memberCount - 1
            };
        case "initJoin":
            return payload;
        default:
            return state;
    }
}